import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { useMap } from 'react-leaflet';
import { fetchAddressFromOla } from '../services/fetchAddressfromOla';
import PropTypes from 'prop-types';
import { faCrosshairs } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
export const apiKey = process.env.REACT_APP_OLA_API_KEY;

const CurrentLocationControl = ({ onLocationFound }) => {
  const map = useMap();
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = () => {
    if (!navigator.geolocation) {
      alert('Geolocation is not supported by your browser.');
      return;
    }

    setIsLoading(true);
    const controller = new AbortController();
    const timeoutId = setTimeout(() => {
      controller.abort();
      setIsLoading(false);
      alert('Location lookup timed out. Please try again.');
    }, 15000); // 15 second timeout

    try {
      map.off('locationfound');
      map.off('locationerror');

      map.locate({
        enableHighAccuracy: true,
        watch: false,
        maximumAge: 0,
        timeout: 12000
      });

      map.on('locationfound', async function (e) {
        try {
          const { lat, lng } = e.latlng;
          const { accuracy } = e;
          const addressDetails = await fetchAddressFromOla(lat, lng, apiKey, {
            signal: controller.signal
          });

          if (!addressDetails?.address) throw new Error('Invalid address data');

          onLocationFound({
            lat,
            lng,
            accuracy: Math.round(accuracy),
            address: addressDetails.address
          });
          map.flyTo([lat, lng], 18);
        } catch (error) {
          console.error('Error:', error);
          alert(error.message || 'Failed to fetch location details');
        } finally {
          clearTimeout(timeoutId);
          setIsLoading(false);
        }
      });

      map.on('locationerror', function (error) {
        clearTimeout(timeoutId);
        console.error('Location error:', error);
        alert(
          'Could not find your location. Please check browser permissions.'
        );
        setIsLoading(false);
      });
    } catch (error) {
      clearTimeout(timeoutId);
      setIsLoading(false);
      console.error('Error in location handling:', error);
    }
  };

  return (
    <div
      className="leaflet-bottom leaflet-right"
      style={{
        position: 'absolute',
        top: '20px',
        right: '10px',
        zIndex: 999
      }}
    >
      <div
        className="leaflet-control leaflet-bar"
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          borderRadius: '8px'
        }}
      >
        <Button
          variant="light"
          onClick={handleClick}
          disabled={isLoading}
          style={{
            padding: '10px',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: '16px'
          }}
        >
          {isLoading ? 'Loading...' : <FontAwesomeIcon icon={faCrosshairs} />}
        </Button>
      </div>
    </div>
  );
};
CurrentLocationControl.propTypes = {
  onLocationFound: PropTypes.func.isRequired // Ensure it's a function and required
};

export default CurrentLocationControl;
